import { Stack, Alert } from "@mui/material"
import Kpi from "../Tools/Kpi"
import { useContext} from "react"
import UserContext from "../../services/Context/UserContext"

export default function Kpis({courses}){

    const {user} = useContext(UserContext)

    const getSum = key => {

        if(!courses) return 0;

        return courses.map(i => i[key]).reduce((a,b) => a + b, 0)
    }

    const getAvg = key => {

        if(!courses) return '';

        return parseFloat((getSum(key) / courses.length).toFixed(2));
    }

    return <Stack spacing={1}>
    
        <Stack direction='row' flexWrap='wrap'>

            <Kpi 
                title={getSum('enrollments').toLocaleString()}
                caption='Inscriptions*'
                icon='people'
                color={user.category?.color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={getSum('cashed').toLocaleString()}
                caption='Encaissements*'
                icon='pig'
                color={user.category?.color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={getAvg('rating').toLocaleString()}
                unit={'/5'}
                caption={`Pour ${getSum('reviews').toLocaleString()} avis`}
                icon='stars'
                color={user.category?.color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={Math.round(getAvg('completion')).toLocaleString()}
                unit={'%'}
                caption='Complétion moy.'
                icon='school'
                color={user.category?.color}
                sx={{mr: 1, mb: 1}}
            />

        </Stack>

        <Alert severity='info'>
            <small>*Le nombre d'inscriptions représente le total des inscriptions effectuées, qu'elles aient été encaissées ou non, incluant toutes les formes de financement.</small>
            <br/>
            <small>*Le nombre d'encaissements fait référence au total des paiements reçus pour les inscriptions, englobant toutes les sources de financement.</small>
            <br/>
            <small>⚠️ Il est crucial de comprendre que la différence entre le nombre d'inscriptions et le nombre d'encaissements est due au délai de paiement par les OPCO ou le DPC. Ce processus peut prendre plusieurs mois, expliquant ainsi la présence normale de cet écart.</small>
            <br/>
            <small>*Les nombres d'inscriptions et d'encaissements sont sujets à variation et sont mentionnés ici à titre indicatif. Ils ne peuvent faire l'objet de quelconques réclamations. Seuls les encaissements sont considérés pour le calcul des royalties dues.</small>
        </Alert>

    </Stack>
}

